import React, { useState } from 'react';
import Book from './BookNow';
import CourseDetails from './Slots';

const HomeContainers = () => {
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleSearch = (courseData) => {
    setSelectedCourse(courseData);
    setIsSearchClicked(true);
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '40px' }}>
        <Book onSearch={handleSearch} />
      </div>

      {/* {isSearchClicked && selectedCourse && (
        <div style={{ marginBottom: '40px' }}>
          <CourseDetails courseData={selectedCourse} />
        </div>
      )} */}
    </div>
  );
};
export default HomeContainers;
